import { useState, useEffect } from "react";

const usePaykassma = () => {
  const [value, setValue] = useState('');
  const [calculatedValue, setCalculatedValue] = useState('');

  const minMax = {
    min: 5,
    max: 150,
  }

  useEffect(() => {
    const numericValue = parseFloat(value);

    if (!isNaN(numericValue) && numericValue > 0) {
      const result = Math.floor((numericValue / 30 * 100) * 10) / 10;
      setCalculatedValue(result);
    } else {
      setCalculatedValue('');
    }
  }, [value]);

  const disabled = !value || parseFloat(value) <= 0 || parseFloat(value) < minMax.min || parseFloat(value) > minMax.max;

  return {
    value,
    minMax,
    setValue,
    disabled,
    calculatedValue,
  };
};

export default usePaykassma;
